import { graph, branch, memberKey } from '../constants'

module.exports = ->
  result = await new Weaver.Query()
    .outsideTransaction()
    .inGraph('$config')
    .hasRelationOut('type')
    .find()

  Promise.map(result, (node) ->
    typeId = node.relation(memberKey).first().id()
    try
      type = await new Weaver.Query(undefined, branch).restrict(typeId).first()
    catch
      type = undefined

    if type?
      try
        nodeToMigrate = await new Weaver.Query(undefined, branch).restrict(node.id()).first()
        nodeToMigrate.relation(memberKey).onlyOnce(type)
      catch
        nodeToMigrate = new Weaver.Node(node.id())
        nodeToMigrate.relation(memberKey).add(type)

      _.map(node.attributes(), (attribute, key) ->
        nodeToMigrate.set(key, attribute)
      )

      nodeToMigrate.save({ branch, commitMessage: "Graph -> Branch migration." })
    else
      Promise.resolve()
  )
